import AdminDataRumah from "./components/admin/AdminDataRumah";
import AdminDashboard from "./AdminDashboard";
import Notification from "./components/Notification";
import AdminLaporan from "./AdminLaporan";
import AdminIuranLainnya from "./AdminIuranLainnya";
import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";

// DIKUNCI: Ikon grafis panah kembali asli
function IconPanahBackSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

// ================= KONFIGURASI UTAMA RT =================
const TARIF_IPL_BULANAN = 100000;
const REKENING_BENDAHARA = {
  bank: "Bank BCA",
  nomor: "5870204291 (Rekening khusus RT)",
  atas_nama: "Meikun Dwi Susanto"
};
// =======================================================

// DAFTAR SELURUH 125 RUMAH WARGA PESONA CIPUTIH
const RAW_HOUSES = [{"nomor_rumah":"C1/1","nama":"Rio Crisvan"},{"nomor_rumah":"C1/2","nama":"Martin Surya M"},{"nomor_rumah":"C1/3","nama":"Rizal"},{"nomor_rumah":"C1/4","nama":"Irfan Adika"},{"nomor_rumah":"C1/5","nama":"Thomas"},{"nomor_rumah":"C1/6","nama":"Lia"},{"nomor_rumah":"C1/7","nama":"Tito Permana"},{"nomor_rumah":"C1/8","nama":"Muhammad Reza"},{"nomor_rumah":"C1/9","nama":"Beny Heryawan"},{"nomor_rumah":"C1/10","nama":"Alfa"},{"nomor_rumah":"C1/12","nama":"Irfan"},{"nomor_rumah":"C1/13","nama":"Reza"},{"nomor_rumah":"C1/14","nama":"Deni"},{"nomor_rumah":"C1/15","nama":"Bayu"},{"nomor_rumah":"C1/16","nama":"Agung"},{"nomor_rumah":"C1/18","nama":"Muslim"},{"nomor_rumah":"C1/19","nama":"Galih"},{"nomor_rumah":"C1/21","nama":"Isan"},{"nomor_rumah":"C1/20","nama":"Doni"},{"nomor_rumah":"C1/22","nama":"Sukoco"},{"nomor_rumah":"C1/23","nama":"Irsyad"},{"nomor_rumah":"C1/24","nama":"Fikri"},{"nomor_rumah":"C1/25","nama":"Ilham"},{"nomor_rumah":"C1/26","nama":"Diki"},{"nomor_rumah":"C1/27","nama":"Anas"},{"nomor_rumah":"C1/28","nama":"Aly"},{"nomor_rumah":"C1/29","nama":"Rizky"},{"nomor_rumah":"C1/30","nama":"Haviz"},{"nomor_rumah":"C1/31","nama":"Ihsan"},{"nomor_rumah":"C1/32","nama":"Harry"},{"nomor_rumah":"C1/33","nama":"Surya"},{"nomor_rumah":"C1/35","nama":"Fajeriannor"},{"nomor_rumah":"C2/1","nama":"Bram"},{"nomor_rumah":"C2/2","nama":"Donatina"},{"nomor_rumah":"C2/3","nama":"Ichsan"},{"nomor_rumah":"C2/4","nama":"Fahmi"},{"nomor_rumah":"C2/5","nama":"Wahyudi"},{"nomor_rumah":"C2/6","nama":"Pramusinto"},{"nomor_rumah":"C2/7","nama":"Fanny"},{"nomor_rumah":"C2/8","nama":"Irfan"},{"nomor_rumah":"C2/9","nama":"Dadan"},{"nomor_rumah":"C2/10","nama":"Sandy"},{"nomor_rumah":"C2/11","nama":"Andika"},{"nomor_rumah":"C2/12","nama":"Noto"},{"nomor_rumah":"C2/13","nama":"Benyamin"},{"nomor_rumah":"C2/14","nama":"Agus"},{"nomor_rumah":"C2/15","nama":"Ryan"},{"nomor_rumah":"C2/16","nama":"Valentino"},{"nomor_rumah":"C2/17","nama":"Pinggir"},{"nomor_rumah":"C2/18","nama":"Erwin G"},{"nomor_rumah":"C2/19","nama":"Irham"},{"nomor_rumah":"C2/20","nama":"Reza"},{"nomor_rumah":"C2/21","nama":"Ayuk"},{"nomor_rumah":"C2/22","nama":"Melki"},{"nomor_rumah":"C2/23","nama":"Aribowo"},{"nomor_rumah":"C2/24","nama":"Puguh"},{"nomor_rumah":"C2/25","nama":"Ian"},{"nomor_rumah":"C2/26","nama":"Danar"},{"nomor_rumah":"C2/27","nama":"Faisal"},{"nomor_rumah":"C2/28","nama":"Candra"},{"nomor_rumah":"C2/29","nama":"Immanuel"},{"nomor_rumah":"C2/30","nama":"Rendi"},{"nomor_rumah":"C2/31","nama":"Krisma"},{"nomor_rumah":"C2/32","nama":"Supri"},{"nomor_rumah":"C2/33","nama":"Sunanto"},{"nomor_rumah":"C2/34","nama":"Herwis G"},{"nomor_rumah":"C2/35","nama":"Agung"},{"nomor_rumah":"C2/36","nama":"Ardika"},{"nomor_rumah":"C2/37","nama":"Yefta"},{"nomor_rumah":"C2/38","nama":"Fandi"},{"nomor_rumah":"C2/39","nama":"Ryan"},{"nomor_rumah":"C2/40","nama":"Teguh"},{"nomor_rumah":"C2/41","nama":"Fajar"},{"nomor_rumah":"C2/42","nama":"Rian Agam"},{"nomor_rumah":"C2/43","nama":"Parsono"},{"nomor_rumah":"C2/44","nama":"Maria"},{"nomor_rumah":"C2/45","nama":"Ali"},{"nomor_rumah":"C2/46","nama":"Ribka"},{"nomor_rumah":"C2/47","nama":"Toga"},{"nomor_rumah":"C2/48","nama":"Edi"},{"nomor_rumah":"C3/1","nama":"Bu Lily"},{"nomor_rumah":"C3/2","nama":"Nova"},{"nomor_rumah":"C3/3","nama":"Sutoro"},{"nomor_rumah":"C3/4","nama":"Dasdo Purba"},{"nomor_rumah":"C3/5","nama":"Faiz"},{"nomor_rumah":"C3/6","nama":"Jody Kurniawan"},{"nomor_rumah":"C3/7","nama":"Andres"},{"nomor_rumah":"C3/8","nama":"Pensi"},{"nomor_rumah":"C3/9","nama":"Ashif"},{"nomor_rumah":"C3/10","nama":"Eka Widia"},{"nomor_rumah":"C3/11","nama":"Harbi Putra"},{"nomor_rumah":"C3/12","nama":"Joy Karo"},{"nomor_rumah":"C3/13","nama":"Dason"},{"nomor_rumah":"C3/14","nama":"Desta"},{"nomor_rumah":"C3/16","nama":"Adit"},{"nomor_rumah":"C3/18","nama":"Joko S"},{"nomor_rumah":"C3/19","nama":"Apri C Ginting"},{"nomor_rumah":"C3/17","nama":"Ashari"},{"nomor_rumah":"C3/20","nama":"Ali"},{"nomor_rumah":"C3/21","nama":"Oscar"},{"nomor_rumah":"C3/22","nama":"Natan"},{"nomor_rumah":"C3/24","nama":"Taju"},{"nomor_rumah":"C3/25","nama":"Tapta"},{"nomor_rumah":"C3/26","nama":"Sriyono"},{"nomor_rumah":"C3/28","nama":"Yani"},{"nomor_rumah":"C4/1","nama":"Yatno"},{"nomor_rumah":"C4/2","nama":"Siska"},{"nomor_rumah":"C4/3","nama":"Rogan"},{"nomor_rumah":"C4/4","nama":"Syaiful"},{"nomor_rumah":"C4/5","nama":"Ridwan"},{"nomor_rumah":"C4/6","nama":"Gilang"},{"nomor_rumah":"C4/7","nama":"Yopi"},{"nomor_rumah":"C4/8","nama":"Sunu"},{"nomor_rumah":"C4/9","nama":"Adi"},{"nomor_rumah":"C4/10","nama":"Galang"},{"nomor_rumah":"C4/12","nama":"Wahyu"},{"nomor_rumah":"C4/13","nama":"Budi"},{"nomor_rumah":"C4/15","nama":"Dedek"},{"nomor_rumah":"C4/16","nama":"Eko"},{"nomor_rumah":"C4/17","nama":"Didin"},{"nomor_rumah":"C4/18","nama":"Yulian"},{"nomor_rumah":"C4/19","nama":"Novel"},{"nomor_rumah":"C4/20","nama":"Sanusi"},{"nomor_rumah":"C4/21","nama":"Mikail"},{"nomor_rumah":"C4/22","nama":"Wahyu"},{"nomor_rumah":"C4/23","nama":"Sugeng"},{"nomor_rumah":"C4/24","nama":"Monald"},{"nomor_rumah":"C4/25","nama":"Asep"},{"nomor_rumah":"C4/26","nama":"Fadhlan"},{"nomor_rumah":"C5/1","nama":"Dean"},{"nomor_rumah":"C5/2","nama":"Boyke"},{"nomor_rumah":"C5/3","nama":"Alan"},{"nomor_rumah":"C5/4","nama":"Frieska"},{"nomor_rumah":"C5/5","nama":"Verdiana"},{"nomor_rumah":"C5/6","nama":"Ester"},{"nomor_rumah":"C6/1","nama":"Kukuh"},{"nomor_rumah":"C6/2","nama":"Noer"},{"nomor_rumah":"C6/3","nama":"Mey"},{"nomor_rumah":"C6/4","nama":"Firhat"},{"nomor_rumah":"C6/5","nama":"Kamaludin"},{"nomor_rumah":"C6/6","nama":"Intan"},{"nomor_rumah":"C6/7","nama":"Rudi"},{"nomor_rumah":"C6/8","nama":"Argie"},{"nomor_rumah":"C6/9","nama":"Alfian"},{"nomor_rumah":"C6/10","nama":"Deby Irawan"},{"nomor_rumah":"C6/11","nama":"Kevin"},{"nomor_rumah":"C6/12","nama":"Rizaldo"},{"nomor_rumah":"C6/13","nama":"Ryan"},{"nomor_rumah":"C6/14","nama":"Alif"},{"nomor_rumah":"C6/15","nama":"Novliansyah"},{"nomor_rumah":"C7/1","nama":"Indra"},{"nomor_rumah":"C7/2","nama":"Alan Bernandho"},{"nomor_rumah":"C7/3","nama":"Yopi"},{"nomor_rumah":"C7/4","nama":"Husen"},{"nomor_rumah":"C7/5","nama":"Kharis"},{"nomor_rumah":"C7/6","nama":"Restu"},{"nomor_rumah":"C7/7","nama":"Asep"},{"nomor_rumah":"C7/8","nama":"Sofwan"},{"nomor_rumah":"C7/10","nama":"Royadi"},{"nomor_rumah":"C7/11","nama":"Pandri"},{"nomor_rumah":"C7/12","nama":"Jati"},{"nomor_rumah":"C7/13","nama":"Beni"},{"nomor_rumah":"C8/1","nama":"Josafat"},{"nomor_rumah":"C8/2","nama":"Dwi"},{"nomor_rumah":"C8/3","nama":"Indra"},{"nomor_rumah":"C8/4","nama":"Ussy"},{"nomor_rumah":"C8/5","nama":"Jelpi"},{"nomor_rumah":"C8/6","nama":"Azis"},{"nomor_rumah":"C8/7","nama":"Sugiyanto"},{"nomor_rumah":"C8/8","nama":"Hartono"},{"nomor_rumah":"C8/9","nama":"Ridwan"},{"nomor_rumah":"C8/10","nama":"Adi"},{"nomor_rumah":"C8/11","nama":"Al-Magribi"},{"nomor_rumah":"C8/12","nama":"Agus"},{"nomor_rumah":"C8/13","nama":"Anggar"},{"nomor_rumah":"C8/14","nama":"Tunggal"},{"nomor_rumah":"C8/15","nama":"Fendy"},{"nomor_rumah":"C8/16","nama":"Arif"}];
const BULAN = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
const TAHUN_AWAL = 2024;
const TAHUN_LIST = [2024,2025,2026,2027,2028];

const styles = {
  app: { minHeight:"100vh", width:"100%", background:"#F3F4F0", fontFamily:"Arial, Helvetica, sans-serif", color:"#1E2A22", display:"flex", flexDirection:"column" },
  centerScreen: { minHeight:"100vh", width:"100%", display:"flex", alignItems:"center", justifyContent:"center", background:"#1E5631", padding:"12px", boxSizing:"border-box" },
  card: { width:"100%", maxWidth:"440px", background:"#fff", borderRadius:"16px", padding:"28px 20px", boxShadow:"0 8px 24px rgba(0,0,0,0.18)", boxSizing: "border-box", margin: "0 auto" },
  input: { width:"100%", padding:"14px 14px", fontSize:"17px", border:"1.5px solid #C9CDC4", borderRadius:"10px", marginBottom:"14px", boxSizing:"border-box", background:"#fff" },
  btnPrimary: { width:"100%", padding:"14px", fontSize:"18px", fontWeight:"bold", color:"#fff", background:"#1E5631", border:"none", borderRadius:"10px", cursor:"pointer" },
  btnGhost: { width:"100%", padding:"12px", fontSize:"16px", fontWeight:"bold", color:"#1E5631", background:"transparent", border:"1.5px solid #1E5631", borderRadius:"10px", cursor:"pointer", marginTop:"10px" },
  header: { background:"#1E5631", color:"#fff", padding:"18px 20px", position:"sticky", top:0, zIndex:5 },
  tabbar: { display:"flex", background:"#fff", borderTop:"3px solid #1E5631", position:"fixed", bottom:0, left:0, right:0, zIndex:100, boxShadow:"0 -4px 16px rgba(0,0,0,0.15)", height: "76px", alignItems: "center", justifyContent: "space-around" },
  tabBtn: (active)=>({
    flex:1,
    height:"100%",
    padding:"6px 2px",
    textAlign:"center",
    fontSize:"12px",      // diperkecil
    color: active?"#1E5631":"#5A6059",
    background:"transparent",
    border:"none",
    fontWeight:"600",      // sedikit lebih ringan
    cursor:"pointer",
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    justifyContent:"center",
    gap:"3px",
    lineHeight:"14px",     // agar teks 2 baris lebih rapi
    whiteSpace:"normal"    // mengizinkan teks membungkus
  }),
  pageTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#1E5631",
    textAlign: "center",
    marginBottom: "20px"
  },
  content: { flex:1, padding:"18px 16px 100px", overflowY:"auto" },
};

function StatusBadge({ status }){
  const map = {
    lunas: { bg:"#DCF1DF", color:"#1E5631", text:"Lunas" },
    menunggu: { bg:"#FCEFD6", color:"#9A6A12", text:"Menunggu verifikasi" },
    belum: { bg:"#FBE0E0", color:"#B23B3B", text:"Belum bayar" },
  };
  const s = map[status] || map.belum;
  return <span style={{fontSize:"13px", fontWeight:"bold", color:s.color, background:s.bg, padding:"4px 10px", borderRadius:"20px"}}>{s.text}</span>;
}

function AdminPembayaran({ daftarWargaRumah }) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [payData, setPayData] = useState({});
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const [daftarBayar, setDaftarBayar] = useState([]);

  // Gabungkan RAW_HOUSES (125 rumah) dengan data warga dari Supabase
  const daftarRumahGabungan = (() => {
    const map = new Map();
    const norm = (s) => String(s || "").replace(/\s+/g, "").toUpperCase();
    RAW_HOUSES.forEach(h => map.set(norm(h.nomor_rumah), h));
    (daftarWargaRumah || []).forEach(h => {
      const key = norm(h.nomor_rumah);
      if (!map.has(key)) map.set(key, h);
    });
    return Array.from(map.values());
  })();

  const muatDataSupabase = async () => {
    try {
      // Ambil semua data dengan pagination karena default Supabase hanya 1000 record
      // Data pembayaran bisa lebih dari 1000 baris (125 rumah x 12 bulan = 1500+)
      const PAGE_SIZE = 1000;
      let allData = [];
      let from = 0;
      let hasMore = true;
      while (hasMore) {
        const { data, error } = await supabase
          .from("pembayaran")
          .select("*")
          .range(from, from + PAGE_SIZE - 1);
        if (error) throw error;
        allData = allData.concat(data || []);
        hasMore = (data || []).length === PAGE_SIZE;
        from += PAGE_SIZE;
      }
      console.log("[AdminPembayaran] muatDataSupabase loaded", allData.length, "records");
      setDaftarBayar(allData);
    } catch (err) {
      console.error("Gagal muat data:", err.message);
    }
  };

  const normalize = (s) => {
    if (s === null || s === undefined) return "";
    try {
      return String(s).normalize('NFKC').replace(/\s+/g, '').replace(/\u00A0/g, '').toUpperCase();
    } catch (e) {
      return String(s).replace(/\s+/g, '').toUpperCase();
    }
  };

  useEffect(() => {
    muatDataSupabase();
    const kanalRealtime = supabase
      .channel("perubahan_pembayaran_rt")
      .on("postgres_changes", { event: "*", schema: "public", table: "pembayaran" }, () => {
        console.log("[Realtime] perubahan_pembayaran_rt fired");
        muatDataSupabase();
      })
      .subscribe();

      return () => {
        supabase.removeChannel(kanalRealtime);
      };
  }, []);

  const rumahTerfilter = daftarRumahGabungan.filter((h) => {
    const kataKunci = (search || "").toLowerCase().trim();
    if (!kataKunci) return true;
    const namaWarga = h.nama ? String(h.nama).toLowerCase() : "";
    const noRumah = normalize(h.nomor_rumah).toLowerCase();
    return noRumah.includes(kataKunci) || namaWarga.includes(kataKunci);
  });

  const openHouse = (h) => {
    setSelected(h);
    const mergedData = {};
    mergedData[tahun] = {};
    const targetNoRumah = normalize(h.nomor_rumah || "");
    const targetTahun = String(tahun).trim();

    const dataWarga = (daftarBayar || []).filter((item) => {
      if (!item) return false;
      const noRumahDb = normalize(item.nomor_rumah || item.no_rumah || "");
      const tahunDb = String(item.tahun || "").trim();
      return noRumahDb === targetNoRumah && tahunDb === targetTahun;
    });

    dataWarga.forEach((item) => {
      const bulanDb = String(item.bulan || "").trim().toUpperCase();
      const bulanIdx = BULAN.map(b => b.toUpperCase()).indexOf(bulanDb);
      if (bulanIdx !== -1) {
        const statusSupa = String(item.status || "").trim().toLowerCase();
        const bukti = item.bukti_foto || item.bukti_transfer;
        let statusFinal;
        if (statusSupa === "lunas" || statusSupa === "success") {
          statusFinal = "lunas";
        } else if (bukti) {
          // Warga sudah upload bukti pembayaran, menunggu verifikasi admin
          statusFinal = "menunggu";
        } else {
          // Tidak ada bukti pembayaran = belum bayar
          statusFinal = "belum";
        }
        mergedData[tahun][bulanIdx] = {
          status: statusFinal,
          proof: bukti,
          id_supabase: item.id
        };
      }
    });
    setPayData(mergedData);
  };

  const verifikasiLunas = async (bulanIdx) => {
    if (!selected) return;
    const targetBulan = BULAN[bulanIdx];
    try {
      // try to find the exact row id in daftarBayar using normalized nomor_rumah, bulan, tahun
      const matchRow = (daftarBayar || []).find((item) => {
        if (!item) return false;
        const noRumahDb = normalize(item.nomor_rumah || item.no_rumah || "");
        const tahunDb = String(item.tahun || "").trim();
        const bulanDb = String(item.bulan || "").trim().toUpperCase();
        return noRumahDb === normalize(selected.nomor_rumah) && tahunDb === String(tahun).trim() && bulanDb === String(targetBulan).toUpperCase();
      });

      let res;
      if (matchRow && matchRow.id) {
        res = await supabase.from("pembayaran").update({ status: "Lunas" }).eq("id", matchRow.id).select();
      } else {
        // fallback to best-effort match by trimmed nomor_rumah
        res = await supabase.from("pembayaran").update({ status: "Lunas" }).match({ nomor_rumah: (selected.nomor_rumah || "").trim(), bulan: targetBulan, tahun: String(tahun) }).select();
      }

      if (res.error) throw res.error;

      await muatDataSupabase();
      setSelected(null);
    } catch (err) {
      alert("Gagal memverifikasi: " + err.message);
    }
  };

  const getStatus = (h, bulanIdx) => {
    const detail = payData[tahun] && payData[tahun][bulanIdx];
    if (detail) return detail.status;
    if (!daftarBayar || daftarBayar.length === 0) return "belum";
    const targetNoRumah = normalize(h.nomor_rumah || "");
    const targetTahun = String(tahun).trim();
    const targetBulan = BULAN[bulanIdx].toUpperCase();

    const dataWarga = daftarBayar.find((item) => {
      if (!item) return false;
      const noRumahDb = normalize(item.nomor_rumah || item.no_rumah || "");
      const tahunDb = String(item.tahun || "").trim();
      const bulanDb = String(item.bulan || "").trim().toUpperCase();
      return noRumahDb === targetNoRumah && tahunDb === targetTahun && bulanDb === targetBulan;
    });

    if (dataWarga) {
      const stat = String(dataWarga.status || "").trim().toLowerCase();
      if (stat === "lunas" || stat === "success") return "lunas";
      const bukti = dataWarga.bukti_foto || dataWarga.bukti_transfer;
      // Hanya "menunggu verifikasi" jika warga sudah upload bukti pembayaran
      if (bukti) return "menunggu";
      // Tidak ada bukti = belum bayar
      return "belum";
    }
    return "belum";
  };

  return (
    <div>
    <div style={styles.pageTitle}>
  💳 Verifikasi Pembayaran IPL Warga
</div>
      <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"14px"}}>
        <button onClick={()=>setTahun(t=>Math.max(TAHUN_AWAL, t-1))} style={{border:"none", background:"#fff", padding:"8px 16px", borderRadius:"8px", fontSize:"18px", fontWeight:"bold", color:"#1E5631"}}>‹</button>
        <div style={{fontSize:"18px", fontWeight:"bold"}}>Tahun {tahun}</div>
        <button onClick={()=>setTahun(t=>Math.min(TAHUN_LIST[TAHUN_LIST.length-1], t+1))} style={{border:"none", background:"#fff", padding:"8px 16px", borderRadius:"8px", fontSize:"18px", fontWeight:"bold", color:"#1E5631"}}>›</button>
      </div>

      <input 
        style={styles.input} 
        placeholder="🔍 Cari nomor rumah / nama warga..." 
        value={search} 
        onChange={(e)=>setSearch(e.target.value)} 
      />
      
      <div style={{display:"flex", flexDirection:"column", gap:"8px"}}>
        {rumahTerfilter.map((h, i) => {
          const hitungMenunggu = (daftarBayar || []).filter((item) => {
            if (!item) return false;
            const noRumahDb = String(item.nomor_rumah || item.no_rumah || "").replace(/\s+/g, "").toUpperCase();
            const tahunDb = String(item.tahun || "").trim();
            const statusDb = String(item.status || "").trim().toLowerCase();
            const bukti = item.bukti_foto || item.bukti_transfer;
            // Hanya dihitung "menunggu verifikasi" jika ada bukti pembayaran yang diupload
            const isMenunggu = (statusDb === "pending" || statusDb === "menunggu") && bukti;
            return noRumahDb === String(h.nomor_rumah || "").replace(/\s+/g, "").toUpperCase() && tahunDb === String(tahun).trim() && isMenunggu;
          }).length;
          
          return (
            <div
            key={i}
            onClick={()=>{ openHouse(h); }} style={{background:"#fff", padding:"14px", borderRadius:"10px", cursor:"pointer", display:"flex", justifyBetween:"space-between", alignItems:"center", borderLeft: hitungMenunggu > 0 ? "5px solid #C98A1B" : "1px solid #EAEBE6"}}>
              <div>
                <strong style={{fontSize:"16px"}}>{h.nomor_rumah}</strong> - <span style={{color:"#5A6059"}}>{h.nama}</span>
              </div>
              {hitungMenunggu > 0 && <span style={{background:"#FFF3CD", color:"#856404", fontSize:"12px", padding:"2px 8px", borderRadius:"10px", fontWeight:"bold"}}>🔔 {hitungMenunggu} Menunggu</span>}
            </div>
          );
        })}
      </div>

      {selected && (
        <div style={{position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", display:"flex", alignItems:"flex-end", justifyContent:"center", zIndex:200}} onClick={()=>setSelected(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#fff", borderRadius:"20px 20px 0 0", padding:"24px 20px 32px", width:"100%", maxWidth:"480px", maxHeight:"85vh", overflowY:"auto"}}>
            <div style={{fontSize:"20px", fontWeight:"bold", color:"#1E5631", marginBottom:"4px"}}>{selected.nomor_rumah}</div>
            <div style={{fontSize:"15px", color:"#5A6059", marginBottom:"16px"}}>Pemilik: <strong>{selected.nama}</strong></div>
            <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
              {BULAN.map((namaBulan, idx) => {
                const status = getStatus(selected, idx);
                const detail = payData[tahun] && payData[tahun][idx];
                return (
                  <div key={idx} style={{background:"#F3F4F0", padding:"12px", borderRadius:"10px", display:"flex", flexDirection:"column", gap:"8px"}}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                      <span style={{fontWeight:"bold", fontSize:"15.5px"}}>{namaBulan}</span>
                      <StatusBadge status={status} />
                    </div>
                    {detail && detail.proof && (
                      <div style={{marginTop:"4px", background:"#fff", padding:"8px", borderRadius:"8px", border:"1px solid #EAEBE6"}}>
                        <div style={{fontSize:"13px", color:"#5A6059", marginBottom:"4px"}}>Bukti Foto Warga:</div>
                        <img src={detail.proof} alt="Struk" style={{width:"100%", maxHeight:"160px", objectFit:"contain", borderRadius:"6px", marginBottom:"8px"}} />
                        {status === "menunggu" && (
                          <button onClick={()=>verifikasiLunas(idx)} style={{...styles.btnPrimary, padding:"8px", fontSize:"14px"}}>✅ Setujui & Tandai Lunas</button>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <button onClick={()=>setSelected(null)} style={styles.btnGhost}>Tutup Panel</button>
          </div>
        </div>
      )}
    </div>
  );
}

function AdminInformasi(){
  const [judul, setJudul] = useState("");
  const [isi, setIsi] = useState("");
  const [list, setList] = useState([]);

  const buatPengumuman = async (e) => {
    e.preventDefault();
  
    if (!judul.trim() || !isi.trim()) return;
  
    const { error } = await supabase
      .from("pengumuman")
      .insert([
        {
          judul: judul.trim(),
          isi: isi.trim()
        }
      ]);
  
    if (error) {
      alert(error.message);
      return;
    }
  
    setJudul("");
    setIsi("");
  
    const { data } = await supabase
      .from("pengumuman")
      .select("*")
      .order("created_at", { ascending: false });
  
    setList(data || []);
  };

  return (
    <div>
      <div style={{fontSize:"19px", fontWeight:"bold", color:"#1E5631", marginBottom:"14px"}}>Siaran Informasi & Pengumuman RT</div>
      <div style={{background:"#fff", padding:"18px", borderRadius:"14px", marginBottom:"18px"}}>
        <form onSubmit={buatPengumuman}>
          <input style={styles.input} placeholder="Judul Pengumuman" value={judul} onChange={e=>setJudul(e.target.value)} required />
          <textarea style={{...styles.input, minHeight:"100px"}} placeholder="Isi detail informasi RT di sini..." value={isi} onChange={e=>setIsi(e.target.value)} required />
          <button type="submit" style={styles.btnPrimary}>📢 Siarkan Sekarang</button>
        </form>
      </div>
    </div>
  );
}

export default function App(){
  const [auth, setAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success"
  });
  const [houses, setHouses] = useState([]);
  const [tab, setTab] = useState("home");
  const [showFabMenu, setShowFabMenu] = useState(false);
  useEffect(() => {

    async function loadWarga() {
  
      const { data, error } = await supabase
        .from("warga")
        .select("*")
        .order("nomor_rumah");
  
      if (error) {
        console.error(error);
        return;
      }
  
      setHouses(data || []);
  
    }
  
    loadWarga();
  
  }, []);
  const handleLogin = (e) => {
    e.preventDefault();
    if(password === "admin123"){
      setAuthenticated(true);
    } else {
      alert("Password Admin Salah!");
    }
  };

  // PEMBATAS KETAT: Mengunci status login tetap aktif di komponen utama
  if(!auth){
    return (
      <div style={styles.centerScreen}>
        <div style={styles.card}>
          <div style={{textAlign:"center", marginBottom:"20px"}}>
            <span style={{fontSize:"40px"}}>💳</span>
            <div style={{fontSize:"22px", fontWeight:"bold", color:"#1E5631", marginTop:"8px"}}>Panel Admin RT.12</div>
            <div style={{fontSize:"13.5px", color:"#5A6059", marginTop:"4px"}}>Sistem Manajemen IPL Paguyuban Blok C</div>
          </div>
          <form onSubmit={handleLogin}>
            <input type="password" style={styles.input} placeholder="Masukkan Password Admin" value={password} onChange={e=>setPassword(e.target.value)} />
            <button type="submit" style={styles.btnPrimary}>Masuk Ke Panel</button>
          </form>
          <div style={{textAlign:"center", marginTop:"14px", fontSize:"13px", color:"#8A8F86"}}>
            Password default admin = <code style={{background:"#EAEBE6", padding:"2px 6px", borderRadius:"4px"}}>admin123</code>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.app}>
      <div style={styles.header}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          <div>
            <div style={{fontSize:"18px", fontWeight:"bold"}}>Admin RT.12</div>
            <div style={{fontSize:"13px", opacity:0.9}}>RT 12 · Pesona Ciputih</div>
          </div>
          <button onClick={()=>setAuthenticated(false)} style={{background:"rgba(255,255,255,0.2)", border:"none", color:"#fff", padding:"6px 12px", borderRadius:"6px", fontWeight:"bold", cursor:"pointer"}}>Keluar</button>
        </div>
      </div>
      <div style={styles.content}>
      {tab !== "home" && (
  <button type="button" onClick={() => setTab("home")} style={{background:"rgba(30,86,49,0.15)", border:"none", color:"#1E5631", width:"40px", height:"40px", borderRadius:"50%", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"18px"}}>
    <IconPanahBackSVG />
  </button>
)}
      {tab === "home" && (
        <div>
          <div style={{fontSize:"28px", fontWeight:"bold", color:"#1E5631", marginBottom:"8px"}}>
            🏠 Menu Utama
          </div>
          <div style={{fontSize:"15px", color:"#666", marginBottom:"24px"}}>
            Silakan pilih menu yang ingin dikelola.
          </div>
        </div>
      )}
      {tab === "home" && (
      <div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "12px",
    marginBottom: "20px"
  }}
>

  <button
    onClick={() => setTab("pembayaran")}
    style={{
      padding: "18px",
      borderRadius: "14px",
      border: "none",
      background: tab === "pembayaran" ? "#1E5631" : "#FFFFFF",
      color: tab === "pembayaran" ? "#FFFFFF" : "#1E5631",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,.08)"
    }}
  >
    💳<br/>
    Pembayaran
  </button>

  <button
    onClick={() => setTab("iuran")}
    style={{
      padding: "18px",
      borderRadius: "14px",
      border: "none",
      background: tab === "iuran" ? "#1E5631" : "#FFFFFF",
      color: tab === "iuran" ? "#FFFFFF" : "#1E5631",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,.08)"
    }}
  >
    💰<br/>
    Iuran
  </button>

  <button
    onClick={() => setTab("laporan")}
    style={{
      padding: "18px",
      borderRadius: "14px",
      border: "none",
      background: tab === "laporan" ? "#1E5631" : "#FFFFFF",
      color: tab === "laporan" ? "#FFFFFF" : "#1E5631",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,.08)"
    }}
  >
    📋<br/>
    Laporan
  </button>

  <button
    onClick={() => setTab("warga")}
    style={{
      padding: "18px",
      borderRadius: "14px",
      border: "none",
      background: tab === "warga" ? "#1E5631" : "#FFFFFF",
      color: tab === "warga" ? "#FFFFFF" : "#1E5631",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,.08)"
    }}
  >
    👥<br/>
    Data Warga
  </button>

  <button
    onClick={() => setTab("informasi")}
    style={{
      padding: "18px",
      borderRadius: "14px",
      border: "none",
      background: tab === "informasi" ? "#1E5631" : "#FFFFFF",
      color: tab === "informasi" ? "#FFFFFF" : "#1E5631",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,.08)"
    }}
  >
    📢<br/>
    Pengumuman
  </button>

</div>
)}
      {tab === "dashboard" && (
<>

<AdminDashboard/>

</>
)}

      {tab === "pembayaran" && (
  <AdminPembayaran daftarWargaRumah={houses} />
)}

{tab === "iuran" && (
  <AdminIuranLainnya
    supabase={supabase}
    styles={styles}
  />
)}

{tab === "laporan" && (
  <AdminLaporan
    supabase={supabase}
    styles={styles}
  />
)}

{tab === "informasi" && (
  <AdminInformasi />
)}

{tab === "warga" && (
  <AdminDataRumah
  houses={houses}
  setHouses={setHouses}
  styles={styles}
/>
)}

</div>



</div>
  );
}